(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = window.scrollY;
      this.scrollDistance = 0;
      this.scrollDirection = 0;
      this.preventReveal = false;
      this.keyboardInteraction = false;
      this.workVersion = 0;
      this.inputAbort = new AbortController();
      const signal = this.inputAbort.signal;
      document.addEventListener('keydown', () => {this.keyboardInteraction = true;}, {signal});
      document.addEventListener('pointerdown', e => {
        this.keyboardInteraction = false;
        if (this.header.contains(e.target)) this.interactionIntent();
      }, {signal, capture:true});
      this.header.addEventListener('focusin', () => {if (this.keyboardInteraction) this.interactionIntent();}, {signal});
      const viewportChanged = () => {this.cancelScrollWork(); this.currentScrollTop = Math.max(0, window.scrollY); this.scrollDistance = 0;};
      window.addEventListener('resize', viewportChanged, {signal});
      window.visualViewport?.addEventListener('resize', viewportChanged, {signal});

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.cancelScrollWork(); this.inputAbort?.abort(); clearTimeout(this.isScrolling);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop);

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay')) {
            this.header.classList.remove('color-background-overlay');
            this.header.classList.add('color-background-overlay-hidden');
          }
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay-hidden')) {
            this.header.classList.add('color-background-overlay');
            this.header.classList.remove('color-background-overlay-hidden');
          }
        }
      }

      const delta = scrollTop - this.currentScrollTop;
      const direction = Math.sign(delta);
      this.scrollDistance = direction === this.scrollDirection ? this.scrollDistance + Math.abs(delta) : Math.abs(delta);
      this.scrollDirection = direction;
      const engaged = this.engaged();
      if (engaged) { this.currentScrollTop = scrollTop; this.scrollDistance = 0; this.reveal(); return; }
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom && this.scrollDistance >= 36) {
        if (this.preventHide) return;
        this.queueScrollWork('hide');
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom && this.scrollDistance >= 12) {
        if (!this.preventReveal) {
          this.queueScrollWork('reveal');
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.queueScrollWork('hide');
        }
      } else if (scrollTop <= this.headerCoords.top) {
        this.queueScrollWork('reset');
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.engaged()) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if (this.header.classList.contains('color-background-overlay')) {
        this.header.classList.remove('color-background-overlay');
        this.header.classList.add('color-background-overlay-hidden');
      }
    }

    engaged() {
      return this.header.classList.contains('vc-nav-open') ||
        (this.keyboardInteraction && this.header.contains(document.activeElement)) || document.querySelector('cart-drawer.active');
    }

    cancelScrollWork() {cancelAnimationFrame(this.scrollFrame); ++this.workVersion;}
    queueScrollWork(action) {
      this.cancelScrollWork(); const version = this.workVersion;
      this.scrollFrame = requestAnimationFrame(() => {if (version === this.workVersion) this[action]();});
    }
    interactionIntent() {
      this.cancelScrollWork(); this.currentScrollTop = Math.max(0, window.scrollY); this.scrollDistance = 0;
      this.reveal();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      if (this.header.classList.contains('color-background-overlay-hidden')) {
        const megaMenus = Array.from(document.querySelectorAll('.mega-menu'));
        if (megaMenus.some((megaMenu) => megaMenu.hasAttribute('open'))) return;
        this.header.classList.add('color-background-overlay');
        this.header.classList.remove('color-background-overlay-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
